module.exports = __webpack_public_path__ + "img/sld_scb_35_t1_b1_green.2ab206b5.svg";